import { IAclAction } from "@common/models";

export const AclAction: IAclAction = {
    Add: "add",
    All: "*",
    Delete: "del",
    Edit: "edit",
    Forget: "forget",
    Login: "login",
    Read: "read",
    Register: "register",
};
